export default {
  list: {
    headers: {
      id: "ID",
      name: "Nazwa firmy",
      accredible: "Accredible",
      manualCertificate: "Certyfikat ręczny",
      employeesCount: "Ilość pracowników",
      maxEmployees: "Limit pracowników",
      pathsCount: "Ilość ścieżek",
    },
    tooltips: {
      employeeAdd: "Dodaj pracownika",
      employeesList: "Lista pracowników",
    },
  },
  form: {
    buttons: {
      send: "Dodaj firmę",
      save: "Zapisz zmiany",
    },
    files: {
      privacyFile: "polityki prywatności",
      tosFile: "regulaminu",
    },
    headers: {
      info: "Informacje",
      settingsPaths: "Ustawienia ścieżek kariery",
      settingsExams: "Ustawienia egzaminów",
      seriesVisibility: "Wykluczenia serii",
    },
    labels: {
      name: "Nazwa firmy",
      maxEmployees: "Limit pracowników",
      pathsWarning: "Ostrzeżenie o ścieżkach",
      unjoinable: "Widoczne ścieżki bez opcji dołączenia",
      isOnboarding: "Onboarding",
      souEnabled: "SOU",
      rpgSkillsEnabled: "RPG",
      rpgAiCollaborationEnabled: "Współpraca z AI (wymaga RPG)",
      pathsPage: "Dostęp do strony ścieżek",
      isPrivacyPolicy: "Polityka prywatności",
      userPathNext:
        "Po zakończeniu ścieżki zezwalaj na automatyczne przejście do kolejnej",
      userPathNextHelp: "Jeśli została dodana.",
      tos: "Dodatkowy regulamin",
      accredible: "Accredible",
      manualCertificate: "Certyfikat ręczny",
      cohort: "Moduł Kohorta",
      isTest: "Firma testowa",
      newUI: "Nowy wygląd",
      rpgLimit: "Limit RPG",
      rpgLimitPlaceholder: "Bez limitu",
      rpgAiBudget: "Miesięczny budżet AI RPG ($)",
      rpgAiBudgetPlaceholder: "Bez limitu",
      rpgAiBudgetHint: "Po osiągnięciu kwoty w danym miesiącu pracownicy nie rozpoczną nowego ćwiczenia.",
      seriesHideMode: "Tryb wykluczania serii",
      seriesHideExcludeOnly: "Wyklucz tylko wybrane serie",
      seriesHideExcludeAllExcept: "Wyklucz wszystkie oprócz wybranych serii",
      seriesHideHiddenSeries: "Serie do wykluczenia",
      seriesHideVisibleSeries: "Serie, które mają pozostać widoczne",
    },
  },
};
